import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';

import { filter, takeUntil } from 'rxjs/operators';
import { ReplaySubject, Subject } from 'rxjs';
import { CommonModule } from '@angular/common';

export enum ScreenType {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop'
}

@Component({
  selector: 'responsive',
  templateUrl: './responsive.component.html',
  styleUrls: ['./responsive.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
})
export class ResponsiveComponent implements OnDestroy {
  private _screens: ScreenType[] = [];

  @Input() set screens(screens: string[]) {
    this._screens = screens as ScreenType[];
  }

  get screens(): ScreenType[] {
    return this._screens;
  }

  public ScreenType = ScreenType;

  public view$: ReplaySubject<ScreenType>;
  private _ngUnsubscribe: Subject<void>;

  constructor(
    private _breakpointObserver: BreakpointObserver,
  ) {
    this._ngUnsubscribe = new Subject();
    this.view$ = new ReplaySubject<ScreenType>();
  }

  ngOnInit(): void {
    this._breakpointObserver
      .observe(['(max-width: 767px)'])
      .pipe(
        filter(result => result.matches),
        takeUntil(this._ngUnsubscribe)
      )
      .subscribe(() => this.view$.next(ScreenType.mobile));
    this._breakpointObserver
      .observe(['(min-width: 768px) and (max-width:1023px)'])
      .pipe(
        filter(result => result.matches),
        takeUntil(this._ngUnsubscribe)
      )
      .subscribe(() => this.view$.next(ScreenType.tablet));
    this._breakpointObserver
      .observe(['(min-width: 1024px)'])
      .pipe(
        filter(result => result.matches),
        takeUntil(this._ngUnsubscribe)
      )
      .subscribe(() => this.view$.next(ScreenType.desktop));
  }

  public ngOnDestroy(): void {
    this._ngUnsubscribe.next();
    this._ngUnsubscribe.complete();
  }
}
